export default {
  methods: {
    getFiltersKey() {
      return `data_table_filters.${this.filterKey}.${window.location.href}`;
    },
    setFilter(key, value, label = null) {

      const filters = this.getFilters();

      const existingFilterIndex = filters.findIndex(filter => filter.key === key);


      if ((value === null || value === "")) {
        if (existingFilterIndex !== -1) {
          filters.splice(existingFilterIndex, 1);
        }
        localStorage.setItem(this.getFiltersKey(), JSON.stringify(filters));
        return;
      }

      if (existingFilterIndex !== -1) {
        filters[existingFilterIndex].value = value;
        filters[existingFilterIndex].label = label;
      } else {
        filters.push({ key: key, value: value, label: label });
      }

      localStorage.setItem(this.getFiltersKey(), JSON.stringify(filters));
    },
    getFilters() {
      const storedFilterKey = this.getFiltersKey();
      const storedFilters = localStorage.getItem(storedFilterKey);
      return storedFilters ? JSON.parse(storedFilters) : [];
    },
    getFilter(key) {
      const filters = this.getFilters();
      if (filters.length) {
        return filters.find(filter => filter.key === key);
      }
    },
    getFilterValue(key) {
      const filter = getFilter(key);
      return filter ? filter.value : null;
    },
    getFilterLabel(key) {
      const filter = getFilter(key);
      return filter ? filter.label : null;
    }
  },
};

